export const TOP_LEVEL_NAVIGATION = [
  { id: "home", labelKey: "nav.home", path: "/" },
  { id: "resource-center", labelKey: "nav.resourceCenter", path: "/urun-kaynak-merkezi", emphasis: true },
];

export const NAVIGATION_GROUPS = [
  {
    id: "corporate",
    labelKey: "nav.corporate",
    items: [
      { id: "about", labelKey: "nav.about", path: "/hakkimizda" },
      { id: "documents", labelKey: "nav.documents", path: "/belgeler" },
      { id: "contact", labelKey: "nav.contact", path: "/iletisim" },
    ],
  },
  {
    id: "brands",
    labelKey: "nav.brandsGroup",
    items: [
      { id: "brands", labelKey: "nav.brands", path: "/markalar" },
    ],
  },
  {
    id: "partnership",
    labelKey: "nav.partnership",
    items: [
      { id: "dealership", labelKey: "nav.dealers", path: "/bayilik" },
      { id: "dealer-network", labelKey: "nav.dealerNetwork", path: "/bayiler" },
      { id: "faq", labelKey: "nav.faq", path: "/sss" },
    ],
  },
];

export const STANDALONE_ROUTE_SLUGS = [
  "hakkimizda",
  "markalar",
  "bayilik",
  "bayiler",
  "sss",
  "iletisim",
  "urun-kaynak-merkezi",
];
